<table
	mat-table
	class="list-container mb-3"
	[dataSource]="dataSource"
	matSort
	matSortActive="{{ sort.active }}"
	matSortDisableClear
	matSortDirection="{{ sort.direction }}"
>
	<ng-container matColumnDef="empty">
		<th mat-header-cell *matHeaderCellDef class="text-center">
			<div class="list-loader" *ngIf="loading$ | async">
				<mat-progress-bar mode="indeterminate"></mat-progress-bar>
			</div>
			<em *ngIf="loading$ | async">Loading jobs...</em>
			<em *ngIf="!(loading$ | async)">No associated field workers</em>
		</th>
	</ng-container>

	<ng-container matColumnDef="lastName">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
		<td mat-cell *matCellDef="let rwic">
			<a [routerLink]="personnelFragments.detail(rwic.id)">
				{{ rwic?.lastName }}, {{ rwic?.firstName }}
			</a>
		</td>
	</ng-container>

	<ng-container matColumnDef="type">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
		<td mat-cell *matCellDef="let rwic">
			{{ rwic?.type | filterFn: displayDescription }}
		</td>
	</ng-container>

	<ng-container matColumnDef="employeeCode">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Employee Code</th>
		<td mat-cell *matCellDef="let rwic">
			{{ rwic?.employeeCode }}
		</td>
	</ng-container>

	<ng-container matColumnDef="status">
		<th mat-header-cell *matHeaderCellDef>Status</th>
		<td mat-cell *matCellDef="let rwic">
			{{ rwic?.status?.description }}
		</td>
	</ng-container>

	<tr
		mat-header-row
		*matHeaderRowDef="resultColumns"
		[class.hidden]="dataSource.data?.length < 1"
	></tr>
	<tr
		mat-header-row
		*matHeaderRowDef="emptyColumns"
		[class.hidden]="dataSource.data?.length > 0"
	></tr>
	<tr mat-row *matRowDef="let job; columns: resultColumns"></tr>
</table>

<div fxLayout fxLayoutAlign="space-between center">
	<mat-paginator
		class.hidden="true"
		pageSize="5"
		[pageSizeOptions]="[5, 10]"
	></mat-paginator>
	<!-- Commenting out until we have a better way to navigate to add rwic without losing context -->
	<!-- <button
		class="mr-4"
		[routerLink]="pathFrags.fieldWorker({ id: 0 })"
		mat-mini-fab color="primary"
		matTooltip="Add RWIC">
		<mat-icon>add</mat-icon>
	</button> -->
</div>
